$(document).ready(function(){

  // pre-button clicked

    $(".shipping-caption").click(function() {
      var submitButton = $(".new-confetti-btn");
      submitButton.click();
    });

  // pre-button click end
  $('.collection-list-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    arrows: true,
    nextArrow: $('.next'),
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.product-media-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    adaptiveHeight: true,
    asNavFor: '.product-media-thumbnail-slider'
  });

  $('.product-media-thumbnail-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product-media-slider',
    dots: false,
    arrows: false,
    focusOnSelect: true
  });

  function filterSlider(selectedAlt) {
      let $mainSlider = $('.product-media-slider');
      let $thumbnailSlider = $('.product-media-thumbnail-slider');

      // First, clear all previous filtering
      $mainSlider.slick('slickUnfilter');
      $thumbnailSlider.slick('slickUnfilter');

      // Now, filter only the matching slides
      let filteredMain = $mainSlider.find('.slick-slide').filter(function () {
          return $(this).find('img').attr('alt') === selectedAlt;
      });

      let filteredThumbs = $thumbnailSlider.find('.slick-slide').filter(function () {
          return $(this).find('img').attr('alt') === selectedAlt;
      });

      if (filteredMain.length > 0) {
          $mainSlider.slick('slickFilter', function () {
              return $(this).find('img').attr('alt') === selectedAlt;
          });

          $thumbnailSlider.slick('slickFilter', function () {
              return $(this).find('img').attr('alt') === selectedAlt;
          });

          // Ensure Slick updates properly
          setTimeout(() => {
              $mainSlider.slick('refresh');
              $thumbnailSlider.slick('refresh');
              $mainSlider.slick('slickGoTo', 0);
          }, 200);
      }
  }

  // **1. Automatically select the first variant on page load**
  let firstVariant = $('.cstm-var-swatch-img input[type="radio"]').first();
  if (firstVariant.length > 0) {
      firstVariant.prop('checked', true); // Select the first variant
      let firstSelectedAlt = firstVariant.attr('data-alt');
      filterSlider(firstSelectedAlt);
  }

  // **2. Update slider on variant change**
  $('.cstm-var-swatch-img input[type="radio"]').on('change', function () {
     let selectedName = $(this).val();
    $(".selected-option-name").html(selectedName);
    let selectedPrice = $(this).attr("data-price");
    $(".new-price-data").html(selectedPrice);
    let variantID = $(this).attr("data-variant-id");
    let productInput = $(".new-product-id");
    productInput.val(variantID);
    let selectedAlt = $(this).attr('data-alt');
      console.log("Selected Variant Alt:", selectedAlt);
      filterSlider(selectedAlt);
  });


  $("video").oncanplay = function() {
    $("video").prop('muted', true);
  };

  $(".mute-video").click(function () {
    if ($("video").prop('muted')) {
      $("video").prop('muted', false);
      $(this).addClass('unmute-video'); // changing icon for button
      btn.innerHTML = "<i class='fas fa-volume-up'></i>";

    } else {
      $("video").prop('muted', true);
      $(this).removeClass('unmute-video'); // changing icon for button
      btn.innerHTML = "<i class='fas fa-volume-mute'></i>";
    }
    console.log($("video").prop('muted'))
  });
  
  
  
  var media=document.getElementsByClassName('desktop-video')[0];
  var media1=document.getElementsByClassName('mobile-video')[0];


  btn_replay.addEventListener("click",function(){
    media.currentTime = '0';
     media1.currentTime = '0';
    media.play();
    media1.play();
  })
  
  $(window).load(function(){
        /*AJAX CODE HERE */
    console.log('loaaadeded');
    });
});


// $(window).load(function(){
//    function hide_zeroes(){
//     var pricetext = $('.price__regular .recharge-inner-most-price').text().replace('.00','');
//     $('.price__regular .recharge-inner-most-price').text().replace('.00','');
//     console.log(pricetext);
//    };
//    window.setTimeout( hide_zeroes, 3000 );
// });